// extracted by mini-css-extract-plugin
export default {"status":"StatusLabel_status__p-GF5","statusIcon":"StatusLabel_statusIcon__b7-l1"};